import { EnrollmentStatusEnum } from '@/models/Enrollment';
import {
  ArrowRightIcon,
  CheckCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';

export type Props = {
  progress: number;
  enrollmentStatus?: EnrollmentStatusEnum;
  icon: React.ReactNode;
  className?: string;
};

export default function CoursePathProgressIcon(props: Props) {
  const { progress, enrollmentStatus, icon } = props;

  if (progress >= 1 || enrollmentStatus === EnrollmentStatusEnum.CONCLUDED) {
    return <CheckCircleIcon className="w-6 h-6 shrink-0 text-success" />;
  }

  if (enrollmentStatus === EnrollmentStatusEnum.CANCELED) {
    return <XCircleIcon className="w-6 h-6 shrink-0 text-red-500" />;
  }

  if (enrollmentStatus === EnrollmentStatusEnum.COURSE_TRANSFERRED) {
    return <ArrowRightIcon className="w-6 h-6 shrink-0 text-secondary" />;
  }
  return icon;
}
